export const PRIMARY_COLOR = '#e53f67'
export const DISABLED_COLOR = '#d9d9d9'
export const SUCCESS_COLOR = '#52c41a'
